import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {Map} from 'immutable';
import DatePicker from 'react-datepicker';
import moment from 'moment';

import {PageHead} from 'components/header/components';
import {Divider, Label} from 'components/common';
import {Error} from 'components/errors';
import Box from 'components/box';
import Input from 'form/input';
import {ButtonDefault} from 'components/buttons';

import {
  changeMailValue,
  submitNewMail,
  loadMailDetail,
  mailCleanStore
} from 'redux/actions/admin/mailing';

const mapStateToProps = state => ({
  item: state.adminMails.get('mailItem'),
  hasError: state.adminMails.get('mailSubmitError'),
  isSubmitting: state.adminMails.get('mailIsSubmitting')
});

const mapDispatchToProps = dispatch => ({
  onValueChange: (value, key) => dispatch(changeMailValue(value, key)),
  onMount: (id) => dispatch(loadMailDetail(id)),
  onSubmit: (event, document_id, id) => {
    event.preventDefault();
    dispatch(submitNewMail('/admin/mailing/detail/', document_id, id))
  },
  onClean: () => dispatch(mailCleanStore())
});

class CreateMail extends Component {

  componentDidMount() {
    if (this.props.match.params.mail_id !== undefined) {
      this.props.onMount(this.props.match.params.mail_id)
    }

    if (this.props.match.params.document_id !== undefined) {
      this.props.onClean();
    }
  }

  render() {

    if (this.props.item === undefined) {
      return null;
    }

    return (
      <div>
        <PageHead>
          <h2>Cтворити розсилку</h2>
        </PageHead>
        <Box title4="Форма створення розсилки:">
          <form
            onSubmit={event => this.props.onSubmit(event, this.props.match.params.document_id !== undefined ? this.props.match.params.document_id : this.props.item.get('document_list').get(0).get('document_data').get('id'), this.props.match.params.mail_id)}>
            <Input
              label="Опис розсилки:"
              placeholder="Введіть короткий опис розсилки"
              onChange={(event) => this.props.onValueChange(event.target.value, 'comment_mailing')}
              value={this.props.item.get('comment_mailing') ? this.props.item.get('comment_mailing') : ''}
            />
            <Label>Термін виконання розсилки: </Label>
            <DatePicker
              locale="uk-UA"
              selected={moment(this.props.item.get('time_mailing')) || moment()}
              onChange={date => this.props.onValueChange(date, 'time_mailing')}
              showTimeSelect
              timeFormat="HH:mm"
              timeIntervals={15}
              dateFormat="DD-MM-YYYY HH:mm"
          />
          <Divider>
            {this.props.isSubmitting ? (
              <ButtonDefault disabled type="submit" value="Зберегти"/>
            ):(
              <ButtonDefault type="submit" value="Зберегти"/>
            )}
          </Divider>
          {this.props.hasError &&
            <Error>
              При створенні розсилки виникла проблема. Перевірте будь-ласка всі поля.
            </Error>
          }
          </form>
        </Box>
      </div>
    )
  }
};

CreateMail.propTypes = {
  item: PropTypes.instanceOf(Map),
  hasError: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  onValueChange: PropTypes.func,
  onSubmit: PropTypes.func.isRequired
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateMail);



// WEBPACK FOOTER //
// ./src/operator/mailing/create.js